import React from 'react';
import useSectionView from '../../hooks/useSectionView';

function BuiltForPDR() {
  const sectionRef = useSectionView('section_viewed_built_for_pdr');
  return (
    <section ref={sectionRef} style={{ backgroundColor: 'var(--signal-soft)', padding: '96px 24px' }}>
      {/* Two columns rather than one 720px block: the heading is short and the
          copy is long, so a single left-aligned column left the right half of
          the section empty at desktop width. Splitting rule + heading from the
          body fills the measure using only the content already here, and drops
          the body to ~75 characters a line — a readable measure, where 720px
          of 17px text ran to ~85. Collapses to one column at ≤640px. */}
      <div className="bp-grid" style={{
        maxWidth: '1120px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: '1fr 1.5fr',
        gap: '56px',
        alignItems: 'start',
      }}>
        <div>
          <div style={{
            width: '40px',
            height: '3px',
            backgroundColor: 'var(--signal)',
            borderRadius: '2px',
            marginBottom: '28px',
          }} />

          <h2 style={{
            fontFamily: 'var(--font-serif)',
            fontSize: '36px',
            color: 'var(--ink)',
            margin: 0,
            lineHeight: 1.15,
          }}>
            Built for PDR, not adapted for it
          </h2>
        </div>

        <div>
          <p style={{
            fontFamily: 'var(--font-sans)',
            fontSize: '17px',
            color: 'var(--slate)',
            lineHeight: 1.75,
            margin: 0,
          }}>
            Every other financial tool was built for online businesses, generic freelancers, or
            year-end tax filing. QuickBooks, Lili, Found, Keeper — none of them were built for the
            reality of paintless dent repair. Hail season income. R&amp;I deals. Cash and check
            payments. Tool and equipment costs that don't fit standard categories. TruFlow is built
            from the ground up for PDR techs — by a PDR family that's lived every part of it.
          </p>

          {/* Secondary by size, not by colour. --mute would be the usual
              de-emphasis, but on --signal-soft it lands around 2.7:1 contrast,
              under the 4.5:1 AA floor for body text. --slate holds ~5.1:1 on
              this background, so the step down is 17px -> 15px instead. */}
          <p style={{
            fontFamily: 'var(--font-sans)',
            fontSize: '15px',
            color: 'var(--slate)',
            lineHeight: 1.7,
            margin: '20px 0 0 0',
          }}>
            TruFlow is built by Aden, whose dad, uncles, and cousins have spent decades chasing hail
            in the PDR industry. We know the financial chaos of 1099 trades work because we've lived
            it. Every feature exists because someone in our family needed it and didn't have it.
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .bp-grid { grid-template-columns: 1fr !important; gap: 28px !important; }
        }
      `}</style>
    </section>
  );
}

export default BuiltForPDR;
